import React from 'react';
import {
  Box,
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { StorefrontFilters as FiltersState } from '../../../types/additionalServiceTypes';

const RADIUS_OPTIONS = [5, 10, 20, 50] as const;

interface Props {
  filters: FiltersState;
  onChange: (updates: Partial<FiltersState>) => void;
  resultsCount: number;
}

function StorefrontFilters({ filters, onChange, resultsCount }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function handleRadiusChange(event: SelectChangeEvent<number>) {
    onChange({ radius: Number(event.target.value) });
  }

  return (
    <Box
      sx={{
        px: { xs: 2, md: 3 },
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: '#fff',
        flexShrink: 0,
      }}
    >
      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={1.5}
        alignItems={isMobile ? 'stretch' : 'center'}
      >
        <OutlinedInput
          value={filters.search}
          onChange={(e) => onChange({ search: e.target.value })}
          placeholder="Buscar serviço..."
          size="small"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.secondary', fontSize: 18 }} />
            </InputAdornment>
          }
          sx={{ flex: 1, minWidth: 0, bgcolor: '#fafafa' }}
        />

        <FormControl size="small" sx={{ minWidth: 140, flexShrink: 0 }}>
          <Select
            value={filters.radius}
            onChange={handleRadiusChange}
            displayEmpty
            sx={{ bgcolor: '#fafafa' }}
          >
            {RADIUS_OPTIONS.map((km) => (
              <MenuItem key={km} value={km}>
                Raio: {km} km
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'nowrap', flexShrink: 0, alignSelf: isMobile ? 'flex-end' : 'center' }}
        >
          {resultsCount} serviço{resultsCount !== 1 ? 's' : ''}
        </Typography>
      </Stack>
    </Box>
  );
}

export default StorefrontFilters;
